// extracted by mini-css-extract-plugin
export default {"oranum":"oranum--odxon2EzDiibAKL","workSection":"workSection--OheTu8YzPgBBnYC","container":"container--_vc6KxkWvxlDokO","registerBlock":"registerBlock--pzmf7R1Q38gOtDE"};